/** This transformer sets fire and water modules to `true` when it's necessary
 * to avoid quote bugs and issues.
 */
export default (kasko) => {
  kasko.addEventListener('route-changed', (changes) => {
    const inputState = kasko.getState('input');
    if (changes.current?.path === 'buildings-risk-questions-1') {
      kasko.dispatchEvent('set-form-input', {
        ...(inputState.fire_basic_coverage && {
          fire_basic_coverage: true,
        }),
        ...(!inputState.water_basic_coverage &&
          !inputState.fire_basic_coverage && {
            water_basic_coverage: true,
          }),
      });
    }
  });
};
